module.exports = __webpack_public_path__ + "img/6_131.d55bf97c.png";